import { useEffect, useState } from 'react';

const useScreen = () => {
  const [docHeight, setDocHeight] = useState(document.documentElement.clientHeight);
  const [docWidth, setDocWidth] = useState(document.documentElement.clientWidth);

  useEffect(() => {
    function onResize() {
      setDocHeight(document.documentElement.clientHeight);
      setDocWidth(document.documentElement.clientWidth);
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return { docHeight, docWidth };
};

export default useScreen;
